import type { AccountTransaction } from '@viilu-web/shared/types/account-transactions'
import { accountTransactionsHeaders } from './accountTransactionsHeaders'
import { TableColumn, TableRow } from 'react-md'
import { parseAmount, parseDate, parseStatus } from './utils'

type AccountTransactionsTableRowProps = {
	transaction: AccountTransaction
}

const AccountTransactionsTableRow = (
	props: AccountTransactionsTableRowProps,
) => {
	const { transaction } = props

	const getAccountTransactionRowValue = (
		transaction: AccountTransaction,
		key: keyof AccountTransaction,
		type: 'string' | 'currency' | 'date' | 'status',
	) => {
		const value = transaction[key]
		switch (type) {
			case 'currency':
				const action = transaction.action
				const prefix = action === 'WITHDRAWAL' ? '-' : '+'
				const depositStyle = { color: 'green', fontWeight: 'bold' }
				const withdrawalStyle = { color: 'red', fontWeight: 'bold' }
				const style = action === 'WITHDRAWAL' ? withdrawalStyle : depositStyle
				return (
					<p style={style}>
						{prefix} {parseAmount(value as string | number)} €
					</p>
				)
			case 'date':
				return <p>{parseDate(value as Date | string)}</p>
			case 'status':
				return <p>{parseStatus(value as string)}</p>
			default:
				return <p>{value as string}</p>
		}
	}

	const renderTableColumns = () => {
		return accountTransactionsHeaders.map((header) => {
			const { key, type } = header
			return (
				<TableColumn key={key}>
					{getAccountTransactionRowValue(transaction, key, type)}
				</TableColumn>
			)
		})
	}

	return (
		<TableRow key={transaction.transactionId}>{renderTableColumns()}</TableRow>
	)
}

export default AccountTransactionsTableRow
